import React from "react";
import { Navigate, useParams } from "react-router-dom";
import ScrollJourney from "../components/ScrollJourney";
import CommodityTabs from "../components/CommodityTabs";
import CommoditySection from "../components/CommoditySection";
import ContactSection from "../components/ContactSection";
import RangeSection from "../components/trading/RangeSection";
import OriginsSection from "../components/trading/OriginsSection";
import { QuoteBand, ExploreBand, PartnershipBand } from "../components/trading/Bands";
import { COMMODITY_DATA, RICE, CHAMPAGNE } from "../mock";

const scrollToContact = () => {
  const el = document.getElementById("contact");
  if (el) el.scrollIntoView({ behavior: "smooth" });
};

export default function TradingPage() {
  const { commodity = "coffee" } = useParams();
  const data = COMMODITY_DATA[commodity];
  if (!data) return <Navigate to="/trading/coffee" replace />;

  return (
    <main key={commodity} data-testid={`trading-page-${commodity}`}>
      <ScrollJourney
        chapters={data.scenes}
        progressLabel={data.progressLabel}
        accent={data.accent}
        ambience={data.ambience}
        topSlot={<CommodityTabs active={commodity} />}
      />
      <RangeSection commodity={commodity} range={data.range} onContact={scrollToContact} />
      <QuoteBand quote={data.quote} />
      <OriginsSection commodity={commodity} origins={data.origins} />
      <ExploreBand active={commodity} />
      <CommoditySection data={commodity === "wine" ? CHAMPAGNE : RICE} flip onContact={scrollToContact} />
      <PartnershipBand />
      <ContactSection
        eyebrow="Get in touch"
        heading="Let's start a"
        emphasis="conversation."
        blurb="Wholesale buyers, roasters, chocolate makers and partners — tell us what you need and our trade desk will be in touch."
      />
    </main>
  );
}
